import { collection, query, where, onSnapshot } from "firebase/firestore";
import { useState, useEffect } from "react";

import { brand } from "../constants/brandVariables/brandVariables";
import type { Challenge } from "../models/challenge.model";
import { firestore } from "../api/firebaseConfig";

export const useGetUpcomingChallenge = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<Challenge[] | null>(null);
  const [error, setError] = useState<string>();

  useEffect(() => {
    const challengesRef = collection(
      firestore,
      "challenges",
      brand.tenantId,
      "records"
    );

    const q = query(
      challengesRef,
      where("gameType", "==", brand.gameType),
      where("status", "==", "upcoming")
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const upcomingChallengesData: Challenge[] = snapshot.docs.map(
          (doc) => doc.data() as Challenge
        );

        upcomingChallengesData.sort(
          (a, b) => a.startDate.seconds * 1000 - b.startDate.seconds * 1000
        );

        setData(upcomingChallengesData);
        setLoading(false);
      },
      (error) => {
        console.error("Error listening to upcoming challenges:", error);
        setError("Error listening to upcoming challenges!");
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  return { loading, data, error };
};
